export default __webpack_public_path__ + "static/media/browser-nw.768c9698.png";